import { render, staticRenderFns } from "./PoliceAllNotification.vue?vue&type=template&id=541543d8"
import script from "./PoliceAllNotification.vue?vue&type=script&lang=js"
export * from "./PoliceAllNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports